var _rect, _ellipse, _ellipse2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 959,
    viewBox: "0 0 1440 959",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 959,
    fill: "#ECEFF3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 720,
    cy: 100.5,
    rx: 1127,
    ry: 711.5,
    fill: "#111D2C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -407,
    y: -611,
    width: 2254,
    height: 1423
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 720,
    cy: 100.5,
    rx: 1127,
    ry: 711.5,
    fill: "#111D2C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118 447.817V439.745C118 439.745 144.827 459.587 164.079 256.799V447.817H118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 447.817V439.745C210 439.745 183.173 459.587 163.921 256.799V447.817H210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.69 447.817H127.468V795.886H200.69V447.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 447.817H210",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.177 462.109H150.823V490.19H177.177V462.109Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.918 577.964H158.082V567.875C158.082 564.344 160.765 561.654 163.921 561.654C167.235 561.654 169.76 564.512 169.76 567.875V577.964H169.918Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.918 604.196H158.082V594.107C158.082 590.576 160.765 587.885 163.921 587.885C167.235 587.885 169.76 590.744 169.76 594.107V604.196H169.918Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.918 668.933H158.082V658.844C158.082 655.313 160.765 652.623 163.921 652.623C167.235 652.623 169.76 655.481 169.76 658.844V668.933H169.918Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.918 795.886H158.082V785.797C158.082 782.266 160.765 779.575 163.921 779.575C167.235 779.575 169.76 782.434 169.76 785.797V795.886H169.918Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.485 482.455C192.797 482.455 195.482 479.595 195.482 476.066C195.482 472.537 192.797 469.676 189.485 469.676C186.174 469.676 183.489 472.537 183.489 476.066C183.489 479.595 186.174 482.455 189.485 482.455Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.079 486.995C169.744 486.995 174.336 482.102 174.336 476.066C174.336 470.029 169.744 465.136 164.079 465.136C158.414 465.136 153.822 470.029 153.822 476.066C153.822 482.102 158.414 486.995 164.079 486.995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.304 482.455C142.615 482.455 145.3 479.595 145.3 476.066C145.3 472.537 142.615 469.676 139.304 469.676C135.992 469.676 133.307 472.537 133.307 476.066C133.307 479.595 135.992 482.455 139.304 482.455Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.575 662.88L164.079 621.851L201.636 661.871",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.468 683.394H200.69",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.079 447.817V362.901",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.121 814.296L183.351 734.382L298.541 592L340.896 814.296H167.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.748 734.663H253.943V748.17H259.748V734.663Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.512 734.663H263.707V748.17H269.512V734.663Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.589 670.413H281.783V683.92H287.589V670.413Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.353 670.413H291.548V683.92H297.353V670.413Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.039 775.839H188.233V789.346H194.039V775.839Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.803 775.839H197.997V789.346H203.803V775.839Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.374 774.526H289.568V788.033H295.374V774.526Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.138 774.526H299.332V788.033H305.138V774.526Z",
    fill: "#0E1D2D"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1098.15 857.092V409.332H1192.85V857.092",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.95 428.72H1115.05V856.939H1175.95V428.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.8 858.008V428.72",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.2 428.72V858.008",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.8 428.72V409.332",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.2 428.72V409.332",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.05 492.381H1098.15",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.05 567.338H1098.15",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.05 642.143H1098.15",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.05 716.948H1098.15",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.85 492.381H1175.95",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.85 567.338H1175.95",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.85 642.143H1175.95",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.85 716.948H1175.95",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.05 492.381H1175.95",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.05 567.338H1175.95",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.05 642.143H1175.95",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.05 716.948H1175.95",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.43 588.253C1156.27 588.253 1165.06 578.889 1165.06 567.338C1165.06 555.787 1156.27 546.423 1145.43 546.423C1134.59 546.423 1125.8 555.787 1125.8 567.338C1125.8 578.889 1134.59 588.253 1145.43 588.253Z",
    fill: "#0E1D2D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M539.861 716.671H581.685",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.275 732.152H581.685",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.574 747.749H584.349",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.872 763.23H585.74",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.171 778.827H587.13",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.586 794.308H588.404",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.922 715.624V732.152",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.55 731.687V748.215",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.55 762.764V779.293",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.574 762.764V779.293",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.995 746.818V763.346",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.872 778.361V794.89",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.922 778.361V794.89",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.375 716.671H727.199",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.674 732.152H727.199",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.088 747.749H729.864",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.387 763.23H731.254",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.685 778.827H732.644",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.984 794.308H733.803",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.436 715.624V732.152",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.065 731.687V748.215",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.065 762.764V779.293",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.088 762.764V779.293",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.393 746.818V763.346",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.436 778.361V794.89",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.877 716.671H870.281",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.06 732.152H870.281",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.243 747.749H872.945",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.426 763.23H874.335",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.724 778.827H875.726",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.907 794.308H877",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.17 715.624V732.152",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.914 731.687V748.215",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.914 762.764V779.293",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.243 762.764V779.293",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.896 746.818V763.346",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.17 778.361V794.89",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 810.836L550.867 696.535C561.873 680.938 586.203 688.62 586.435 707.709L587.362 785.927C587.593 805.016 611.923 812.698 622.929 797.101L694.296 696.418C705.302 680.938 729.632 688.504 729.864 707.593L730.791 785.811C731.022 804.9 755.352 812.582 766.358 796.985L837.725 696.302C848.731 680.821 873.061 688.387 873.293 707.476L874.915 812",
    stroke: "white",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M948.126 716.362H899V811.871H948.126V716.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.017 709.137H909.11V716.362H938.017V709.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.77 709.137H1025.86V716.362H1054.77V709.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.73 716.362H994.033V779.734H1064.73V716.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.826 684.676C1024.59 684.676 1059.26 681.981 1059.26 678.655C1059.26 675.33 1024.59 672.634 981.826 672.634C939.06 672.634 904.392 675.33 904.392 678.655C904.392 681.981 939.06 684.676 981.826 684.676Z",
    stroke: "white",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.33 678.655V697.923C1059.33 701.234 1024.66 703.944 981.901 703.944C939.14 703.944 904.467 701.234 904.467 697.923V678.655C904.467 681.967 939.14 684.676 981.901 684.676C1024.66 684.676 1059.33 681.967 1059.33 678.655Z",
    stroke: "white",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899 811.871H1064.73V716.362H899",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.126 729.006H994.033",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.126 741.726H994.033",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.126 754.37H994.033",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.126 767.089H994.033",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.126 779.734H1064.73",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.126 781.089V811.871",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.826 781.089V811.871",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.312 683.096V703.116",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.826 683.096V703.116",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.87 683.096V703.116",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.32 683.096V703.116",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.31 781.089V811.871",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899 716.362H1066",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1410 701L1401.82 608.479L1405.91 552.85H1401.82L1405.91 497.076H1401.82L1405.91 441.301H1401.82L1405.91 385.527H1401.82L1405.91 329.753H1401.82L1405.91 274.124H1387.66V249.723H1380.36V239.265H1370.87V171H1363.13V239.265H1353.64V249.723H1346.49V274.124H1328.09L1332.32 329.753H1328.09L1332.32 385.527H1328.09L1332.32 441.301H1328.09L1332.32 497.076H1328.09L1332.32 552.85H1328.09L1332.32 608.479L1324 701H1410Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.09 274.124H1405.91",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405.91 329.753H1328.09",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405.91 385.527H1328.09",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.09 441.301H1405.91",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.09 497.076H1405.91",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.09 552.85H1405.91",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.09 649.583H1405.91",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.13 614.579H1347.36",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.13 601.217H1347.36",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.78 614.579H1404.01",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.78 601.217H1404.01",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.07 627.506C1377.96 627.506 1386.78 618.727 1386.78 607.898C1386.78 597.069 1377.96 588.29 1367.07 588.29C1356.19 588.29 1347.36 597.069 1347.36 607.898C1347.36 618.727 1356.19 627.506 1367.07 627.506Z",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1233.21 754.402H1293.41L1300.49 527H1226L1233.21 754.402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.25 545.172H1300.37",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.25 563.596H1300.37",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.25 582.021H1300.37",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.25 600.445H1300.37",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.25 618.869H1300.37",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.25 637.294H1300.37",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.25 655.718H1300.37",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.25 674.142H1300.37",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.25 692.567H1300.37",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.25 710.865H1300.37",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.25 729.289H1300.37",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2581 787.446H93.8693L101 509.604H26L33.2581 787.446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2428 493.66H87.8845L85.8472 512.082H41.2801L39.2428 493.66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8744 493.66H60.253L60.5076 475.238H66.4923L66.8744 493.66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 509.604H101",
    stroke: "#0E1D2D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327 804H465L422.217 672.341L358.417 627.183L327 804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.105 667.435H365.387V679.412H370.105V667.435Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.04 667.435H373.322V679.412H378.04V667.435Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.368 686.481H382.65V698.457H387.368V686.481Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.303 686.481H390.585V698.457H395.303V686.481Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.294 756.51H424.576V768.486H429.294V756.51Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.228 756.51H432.51V768.486H437.228V756.51Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.811 756.51H355.093V768.486H359.811V756.51Z",
    fill: "#0E1D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.746 756.51H363.028V768.486H367.746V756.51Z",
    fill: "#0E1D2D"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 959,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 539.087,
    fill: "white",
    transform: "translate(118 256.799)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 197,
    fill: "white",
    transform: "translate(187 592)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 450.966,
    fill: "white",
    transform: "translate(1096 407.042)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167,
    height: 143,
    fill: "white",
    transform: "translate(899 670)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.4936,
    height: 227.402,
    fill: "white",
    transform: "translate(1226 527)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 312.208,
    fill: "white",
    transform: "translate(26 475.238)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgMobile);
export default __webpack_public_path__ + "static/media/bg-mobile.6cad324a94246d0d8e45eb0c6b37419f.svg";
export { ForwardRef as ReactComponent };